import React, { useState } from 'react'
import { Button, Message } from 'semantic-ui-react'
import { markDealLost } from 'utility/services/crm'
import { toApiError } from 'utility/crm/api-error'
import { ALL_CRM_SCOPES, invalidateCrm, useCrmLookups, useCrmToast } from 'hooks/crm'
import { CrmModal } from './CrmOverlay'

/**
 * Mark a deal lost with a reason from Lookups.LostReasons.
 * @param {{ deal: import('utility/crm/types').CrmDeal|null, onClose: () => void }} props
 */
export const LostDialog = ({ deal, onClose }) => {
    const { lookups } = useCrmLookups()
    const { successToast } = useCrmToast()
    const [reason, setReason] = useState('')
    const [busy, setBusy] = useState(false)
    const [error, setError] = useState(null)

    const submit = async () => {
        setBusy(true)
        setError(null)
        try {
            await markDealLost(deal.DealId, reason)
            successToast('Deal marked lost')
            invalidateCrm(...ALL_CRM_SCOPES)
            onClose()
        } catch (err) {
            setError(toApiError(err).message)
            // 409 DEAL_NOT_OPEN means someone else changed it: show the fresh state.
            invalidateCrm('deals', 'forecast')
        } finally {
            setBusy(false)
        }
    }

    return (
        <CrmModal
            open={Boolean(deal)}
            onClose={busy ? () => {} : onClose}
            title="Mark deal lost"
            subtitle={deal ? `${deal.AccountName} · ${deal.Name}` : ''}
            width={440}
            footer={
                <>
                    <Button type="button" onClick={onClose} disabled={busy}>
                        Cancel
                    </Button>
                    <Button type="button" negative onClick={submit} loading={busy} disabled={busy || !reason}>
                        Mark lost
                    </Button>
                </>
            }
        >
            {error ? (
                <Message negative role="alert">
                    {error}
                </Message>
            ) : null}
            <label htmlFor="crm-lost-reason" style={{ display: 'block', marginBottom: 6, fontWeight: 600 }}>
                Why was it lost?
            </label>
            <select id="crm-lost-reason" className="ui fluid dropdown" value={reason} onChange={event => setReason(event.target.value)} style={{ width: '100%', padding: 8 }}>
                <option value="">Choose a reason…</option>
                {(lookups?.LostReasons || []).map(r => (
                    <option key={r} value={r}>
                        {r}
                    </option>
                ))}
            </select>
        </CrmModal>
    )
}
